import apiSlice from '../api/api.slice';
import { CNCBrandI } from './cncBrand';

const cncBrand = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCNCBrands: builder.query<CNCBrandI[], void>({
      query: () => ({
        url: '/api/v1/cncBrand/getBrands',
        method: 'GET',
      }),
      transformResponse: (response: { brands: CNCBrandI[] }) => response.brands,
    }),
  }),
});

apiSlice.enhanceEndpoints({
  addTagTypes: ['cncBrand'],
  endpoints: {
    providesTags: ['cncBrand'],
  },
});

export const { useGetCNCBrandsQuery } = cncBrand;
